var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box-inner"},_vm._l((_vm.items),function(item,i){
var _obj, _obj$1;
return _c('div',{key:i,staticClass:"item",class:( _obj = {
        'is-selected': item.selected,
        'disabled': item.disabled
      }, _obj[((item.classname) + "-wrapper")] = true, _obj ),on:{"click":function($event){return _vm.onItemClicked(item)}}},[_c('div',[(item.type === 'none')?_c('i',{staticClass:"no-anim"}):_c('i',{staticClass:"is-short",class:( _obj$1 = {}, _obj$1[("icon-" + (item.name) + "-anim")] = true, _obj$1 )})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.text))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2725076b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popupsNew/effectSetting/boxOne.vue
// module id = null
// module chunks = 